<template>
  <div>
    <a-spin :spinning="loading">
      <div class="custom-padding-bottom-10px">
        <div
          ref="statisticsChart"
          style="height: 300px;"
        />
      </div>
    </a-spin>
  </div>
</template>

<script>
import {
  findOrderFeeDistributionStatistics
} from '@/api/order_statistic'

export default {
  // 订单状态数量统计图
  name: 'FeeDistributionStatisticsChart',
  props: {
    beginTime: {
      type: String,
      required: true
    },
    endTime: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: true,
      data: [],
      // 图表
      chart: null,
      // 总数
      total: 0
    }
  },
  mounted() {
    this.fetchData()
  },
  computed: {
    // 图表默认配置
    chartOption() {
      return {
        // 标题
        title: {
          text: '费用分布',
          bottom: 0,
          left: 'center'
        },
        // 提示框
        tooltip: {
          trigger: 'item',
          formatter: (params) => {
            return params.marker + this.$lodash.truncate(params.data.name, { length: 6 }) +
                '&nbsp;&nbsp;' + params.value + '元'
          }
        },
        // 图例
        legend: {
          orient: 'vertical',
          top: 'middle',
          right: 0,
          type: 'scroll'
        },
        // 数据组
        series: [
          {
            avoidLabelOverlap: false,
            label: { show: false },
            labelLine: { show: true },
            type: 'pie',
            radius: '70%',
            data: [],
            left: 'center'
          }
        ]
      }
    }
  },
  methods: {
    // 绘制图表
    drawChart() {
      this.chart ||= this.$echarts.init(this.$refs.statisticsChart, 'echarts_custom')
      this.chartOption.series[0].data = []
      for (let i = 0; i < this.data.length; i++) {
        const statistic = this.data[i]
        this.chartOption.series[0].data[i] = {
          name: this.$lodash.truncate(statistic.name, { length: 6 }),
          value: statistic.fee
        }
      }
      // 全部重新加载-解决tooltip.formatter params不更新的问题
      this.chart.setOption(this.chartOption, true)
      // 添加表格自适应
      window.addEventListener('resize', () => {
        this.chart.resize()
      })
    },

    fetchData() {
      this.loading = true
      this.total = 0
      findOrderFeeDistributionStatistics({ date_begin: this.beginTime, date_end: this.endTime }).then((res) => {
        if (res.code === 0) {
          if (res.data) {
            this.data = res.data
          } else {
            this.data = [{
              name: '殡仪服务费用',
              fee: 0
            },
            {
              name: '附加产品费用',
              fee: 0
            },
            {
              name: '厅房费用',
              fee: 0
            }]
          }
          this.drawChart()
        }
        this.loading = false
      })
    }
  },
  watch: {
    // 监听间隔时间
    intervalTime() {
      this.fetchData()
    }
  },
  beforeDestroy() {
    // 移除chart表格自适应监听
    window.removeEventListener('resize', () => {
      this.chart.resize()
    })
  }
}
</script>

<style lang="less" scoped>
.total {
  width: 100%;
  font-size: 30px;
  position: absolute;
  top: 38%;
  text-align: center;
}
</style>
